// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__3TZ6r","mainSection":"App_mainSection__1qSkj","secondarySection":"App_secondarySection__3VvuJ","navBar":"App_navBar__3CtP1"};